module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "ui dimmable",
    class: [{
      'dimmed': _vm.hovered
    }],
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": _vm.select
    }
  }, [_c('div', {
    staticClass: "ui simple dimmer",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.status ? _vm.booking.status.toUpperCase() : 'OPEN'))])]), _vm._v(" "), (_vm.booking.reservation) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.reservation ? _vm.booking.reservation.contact.firstName +
    ' ' +
    _vm.booking.reservation.contact.lastName : ''))])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.reservation.code))])]) : _vm._e(), _vm._v(" "), (!_vm.boat.startsAtHalfHour) ? _c('p', [_vm._v(_vm._s(_vm.hour) + " Uhr")]) : _c('p', [_vm._v("\n          " + _vm._s((parseInt(_vm.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(_vm.hour.split(' - ')[1]) - 1) + ':30') + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "booking-field",
    class: [
      _vm.booking.status,
      {
        'create-selected': _vm.createSelected
      },
      {
        'unconfirmed': _vm.booking.reservation && !_vm.booking.reservation.confirmed
      },
      {
        'ui dropdown': ['reserved', 'selected', 'blocked', 'open', 'readyToGo', 'boatOut', 'returned'].indexOf(_vm.booking.status) > -1
      },
      {
        'moving': _vm.moving
      }
    ]
  }, [(_vm.booking.status === 'blocked') ? _c('p', [_c('strong', [_vm._v("INTERNAL BLOCK")])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('p', [_vm._v(_vm._s(_vm.booking.reservation.contact.firstName) + " " + _vm._s(_vm.booking.reservation.contact.lastName))]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation && _vm.booking.reservation.confirmed) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.reservation.code))])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('table', {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "1px solid #fff",
      "color": "#fff"
    }
  }, [_c('tr', [_vm._l((_vm.booking.reservation.services), function(service) {
    return _c('td', {
      staticClass: "service letter",
      staticStyle: {
        "color": "#fff"
      }
    }, [(service.selected) ? _c('strong', [_vm._v(_vm._s(service.letter))]) : _vm._e()])
  }), _vm._v(" "), _c('td', {
    staticClass: "service letter"
  }, [(_vm.booking.reservation.questions) ? _c('strong', [_vm._v("Q")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "service letter"
  }, [(_vm.booking.reservation.wishes) ? _c('strong', [_vm._v("W")]) : _vm._e()])], 2)]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "5px",
      "padding-right": "5px",
      "color": "#fff",
      "font-size": "12px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.booking.reservation.people) + "\n      "), (_vm.booking.discount && _vm.booking.discount.voucher) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.booking.discount.voucher) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation && !_vm.booking.reservation.confirmed) ? _c('div', {
    staticClass: "ui mini label"
  }, [_c('strong', [_vm._v("UNCONFIRMED")])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.viewDetails
    }
  }, [_c('i', {
    staticClass: "info icon"
  }), _vm._v(" View Details")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.booking.status === 'readyToGo') ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.goOut
    }
  }, [_c('i', {
    staticClass: "sign out icon"
  }), _vm._v(" Boat Went Out")]) : _vm._e(), _vm._v(" "), (_vm.booking.status === 'boatOut') ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.returned
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Boat Returned")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.cancelBooking
    }
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Cancel This Booking Slot")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.cancelReservation
    }
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Cancel Whole Reservation")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.moveBooking
    }
  }, [_c('i', {
    staticClass: "exchange icon"
  }), _vm._v(" Move Booking")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.extendBooking
    }
  }, [_c('i', {
    staticClass: "hourglass end icon"
  }), _vm._v(" Extend Booking")])]) : (_vm.booking.status === 'open' || _vm.booking.status === 'selected') ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.blockSlot
    }
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Block Booking Slot")])]) : (_vm.booking.status === 'blocked') ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.unblockSlot
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Unblock Booking Slot")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68e80e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/BookingChoice.vue
// module id = 743
// module chunks = 1